import React from "react";
import {Overlay, Tooltip as TooltipBootstrap} from 'react-bootstrap';


export default class Tooltip extends React.Component<{ placement: string, className?: string }, { isOpen: boolean }> {
    private parentNode: any;
    private dir: any;

    constructor(props) {
        super(props);
        this.state = {
            isOpen: false
        };
        this.parentNode = null;
        this.onMouseLeave = this.onMouseLeave.bind(this);
        this.onMouseEnter = this.onMouseEnter.bind(this);
        this.dir = document.documentElement.getAttribute('dir');
    }

    componentDidUpdate(prevProps: any, prevState: any, snapshot: any) {
        this.dir = document.documentElement.getAttribute('dir');
    }

    componentWillUnmount() {
        if (this.parentNode) {
            this.parentNode.removeEventListener('mouseleave', this.onMouseLeave);
            this.parentNode.removeEventListener('mouseenter', this.onMouseEnter);
        }
    }

    onMouseLeave() {
        if (this.state.isOpen) {
            this.setState({isOpen: false});
        }
    }

    onMouseEnter() {
        if (!this.state.isOpen) {
            this.setState({isOpen: true});
        }
    }

    render() {
        if (this.parentNode) {
            const {children} = this.props;
            let {placement} = this.props;
            if (this.dir === 'rtl') {
                if (placement === 'left') {
                    placement = 'right';
                } else if (placement === 'right') {
                    placement = 'left';
                }
            }
            return (
                <Overlay
                    show={this.state.isOpen}
                    // @ts-ignore
                    placement={placement}
                    delay={{show: 250, hide: 400}}
                    target={this.parentNode}
                >
                    {(props) => <TooltipBootstrap {...props} className={this.props.className}>
                        {children}
                    </TooltipBootstrap>}
                </Overlay>
            )
        }
        return <div ref={d => {
            if (d) {
                this.parentNode = d.parentElement;
                if (this.parentNode) {
                    this.parentNode.addEventListener('mouseleave', this.onMouseLeave);
                    this.parentNode.addEventListener('mouseenter', this.onMouseEnter);
                }
                this.forceUpdate();
            }
        }}/>;
    }
}